import React from 'react';
/**
 *
 */
export default function DataTableLoading({isLoading = false}) {
  return (
    <>
      {isLoading && (
        <div
          id="DataTables_Table_0_processing"
          className="dt-processing card d-flex align-items-center"
        >
          <div className="rbt-loader spinner-border spinner-border-md"></div>
          <div>資料載入中...</div>
          <div></div>
        </div>
      )}
    </>
  );
}
